import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import RgbColorPicker from './RgbColorPicker';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code'; //Qr code changes

const Menu = () => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [activeSubMenuId, setActiveSubMenuId] = useState(null);
   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [widthUpdate, setwidthUpdate] = useState(false);
   const [productType, setproductType] = useState([]);
   let howtoUseD = false;

   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);
            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;
            window.langugageTranslationFlag = setmydata.LangugageTranslation;//translation fix

            // window.productId = setmydata.productId;
            window.name = setmydata.productId;
            // @rajnikant getting nameofShader in data.json start
            window.alienFxData = setmydata['alienFx'];
            // @rajnikant getting nameofShader in data.json end
            window.currentAccordianActiveMenuID = `accordion_${setmydata['currentAccordianActiveMenu']}`;
            let feature_list;
            let menuData;
            let productTypeData;
            let uiData;
            let bodyTag = document.getElementsByTagName("BODY")[0]; //translation fix

             // Changes for QR code update start
             if (window.location.href) {
               let url = window.location.href.split('?')[0];
               let params = window.location.href.split('?')[1];
               let newParams = '?qr=1';
               if (!url.endsWith('index.html')) {
                  if (!url.endsWith('/')) url += '/';
                  url += 'index.html';
               }
               if(params != undefined){
                  newParams = newParams + '&' + params;
               }

               // To Generate the Content QR code for loader image only
               // const conentUrl = "https://content.hmxmedia.com/alienware-area-51-aat2255-gaming-desktop/index.html";
               // window.linkForGenerateQR = `${conentUrl}?qr=1`;

               // for generate dynamic QR Code
               let newUrl
               newUrl = url + newParams;
               window.linkForGenerateQR = `${newUrl}`;
            }
              // Changes for QR code update end

             if (setmydata.menus[window.LangName] == undefined || !setmydata.LangugageTranslation) { //translation fix
               uiData = setmydata.menus.EN[0];
               bodyTag.classList.add('en'); //translation fix

            } else {
               uiData = setmydata.menus[window.LangName][0];
               bodyTag.classList.add(window.LangName.toLowerCase()); //translation fix
            }
            window.dataUI = uiData;
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
               feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus[window.LangName].filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");
            }
            else {
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               // var mobProducts = menuData[0].items;
               feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus.EN.filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");

            }
            setMenuList(menuData);
            setuiDataList(uiData);
            setfeatureMenuList(feature_list)
            setproductType(productTypeData);
            langTranslationAlignment(menuData);
            if (setmydata["accordianClick"]) {
               const setAllItems = () => {
                  const allItemsObj = menuData.flatMap((obj) => [
                     obj.id,
                     ...obj.items.map((item) => item.id),
                  ]);
                  setbuttonArray(allItemsObj);
               };
               setAllItems();
               const setAllAccordion = () => {
                  const allAccordionObj = menuData.flatMap((obj) => [
                     obj,
                     ...obj.items.map((item) => item),
                  ]);
                  setbuttonArrayObjectList(allAccordionObj);
               };
               setAllAccordion();
               // console.log(buttonArrayObjectList)
            } else {
               menuData.map((menu) => {
                  menu.items.map(item => {
                     if (item.id !== undefined) {
                        setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                        setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
                     }
                  })
               })
            }
         });
   }

   const langTranslationAlignment = (menuData) => {
      if (!window.dataUI) return;

      const { ui } = window.dataUI;
      document.title = ui.projectTitle;

      const elements = {
         moveText: document.getElementById('move_text'),
         rotateText: document.getElementById('rotate_text'),
         zoomText: document.getElementById('zoom_text'),
         exploreButton: document.getElementById('exploreButtton'),
         previousView: document.getElementById("previousView"),
         resetView: document.getElementById("resetView"),
         nextView: document.getElementById("nextView"),
         mobHowToUseText: document.getElementById("mobHowToUseText"),
         moveHowToUse: document.getElementById("move_how_to_use"),
         rotateHowToUse: document.getElementById("rotate_how_to_use"),
         zoomHowToUse: document.getElementById("zoom_how_to_use"),
         accordionContainer: document.getElementById("accordionContainer"),
         tooltipText: document.querySelector(".tooltiptext"),
         webXRTEXT: document.querySelector(".portraitButtonText"),
         selectProductMob: document.getElementById("select_type1"),
         mobTypeMenu: document.querySelector(".portraitButtonProducttypeMenu"),
         howPopMoveText: document.querySelector("#move span"),
         howPopRotateText: document.querySelector("#rotate span"),
         howPopZoomText: document.querySelector("#zoom span"),
         howPopMoveImg: document.querySelector("#move img"),
         howPopRotateImg: document.querySelector("#rotate img"),
         howPopZoomImg: document.querySelector("#zoom img")
      };

      // Set text content
      elements.moveText.innerHTML = ui.move;
      elements.rotateText.innerHTML = ui.rotate;
      elements.zoomText.innerHTML = ui.zoom;
      elements.exploreButton.innerHTML = ui.exploreProductIn3D;
   }

   useEffect(() => {
      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;
   })

   useEffect(() => {
      setTimeout(() => {
         getData();
      }, 1000);

   }, [])

   window.checkWindowSize = function () {
      setwidthUpdate(window.mob)
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }
            }
         }
      }
   }

   const howToUSEClick = (e) => {

      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      document.querySelector('#howToUSEText').focus();
      if (howtoUseD) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });

         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '1');
         });
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#410290";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }

   const closeHandle = (event) => {
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const closeHandleMenu = (event) => {
      //TabIndex Click Functionality
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });

         document.querySelector('#howToUseMenu').focus();
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }
   };

   const accordionMenu = (e) => {
      //For setting Accordion aria-expanded collpase
      let currentTargetAccordion1 = e.target.closest(".menu");
      let currentTargetAccordion1Arr = [...document.getElementsByClassName("menu")];
      currentTargetAccordion1Arr.forEach(menuItem =>  menuItem.setAttribute("aria-expanded", "false"));

      currentTargetAccordion1.setAttribute("aria-expanded", "false");
      //For setting SubMenuButton TabIndex -1 and aria-hidden true
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      subMenuTabIndex1Arr.forEach((ele) => {
         ele.setAttribute("tabIndex", "-1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "true");
         }

         const childIds = ["alienFX", "cryotech", "frontControl", "rearControl"];

         setTimeout(() => {
                  childIds.forEach(id => {
                     const childEl = document.getElementById(`menu_id_${id}`);
                     if (childEl) {
                        childEl.setAttribute("tabindex", "-1");
                        childEl.style.display = 'none'
                     }
                  });
         }, 50);

         setActiveSubMenuId(null);
         setTimeout(() => {
            const activeMenu = document.querySelector('.menu.active');
            if (activeMenu && activeMenu.nextSibling) {
               const submenuContent = activeMenu.nextSibling.firstChild;
               if (submenuContent) {
                  activeMenu.nextSibling.style.height = submenuContent.offsetHeight + 'px';
               }
            }
         }, 50);
         
      });

      // For Radio: input should be TabIndex -1
      let subMenuRadioTabIndex1 = document.querySelectorAll(
         ".radioFocus[tabIndex='1']"
      );
      let subMenuRadioTabIndex1Arr = [...subMenuRadioTabIndex1];
      subMenuRadioTabIndex1Arr.forEach((ele) => {
         ele.setAttribute("tabIndex", "-1");
      });

      let subMenu = document.querySelectorAll(".subMenuBtn.list")
      subMenu.forEach((item) => {
         item.classList.remove('active');
      })
      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      
      myJson.menus.EN.map((menu_Item) => {
         if ("accordion_" + menu_Item['id'] === e.target.closest('.menu').id) {
            window.currID = menu_Item['id'];
            window.checkedButton = menu_Item['id'];
            return window.execute_all(menu_Item);
         }
      })

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';
         }
      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {
               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }

         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }

         //TabIndex Click Functionality
         //make tabIndex 1
         let currentTargetAccordion = e.target.closest(".menu.active");
         let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
         let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll(".subMenuBtn");
         let subMenuElementArr = [...subMenuElement];
         currentTargetAccordion.setAttribute("aria-expanded", "true");

         subMenuElementArr.forEach((ele) => {
            // Check if the element has the class 'radioButton'
            if (ele.classList.contains("radioButton")) {
               ele.setAttribute("tabIndex", "-1");
               ele.childNodes[0].setAttribute("tabIndex", "1");
            } else {
               ele.setAttribute("tabIndex", "1");
            }
            let parentElement = ele.parentElement;
            if (parentElement) {
               parentElement.setAttribute("aria-hidden", "false");
            }
         });

      }

      // @rajnikant added for gpu image start
      const getIconImage = document.querySelector("#iconContainerimg img");
      getIconImage.style.display = 'none'
      // @rajnikant added for gpu image end

      if (orentation === 90) {
         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
      }
      window.updateSlider()
   }

   const subMenu = (e) => {
      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }

   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }

   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;
      if (isChecked === true) {
         window.animationStatus = 'on';
      } else {
         window.animationStatus = 'off';
      }
   }

   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;
      if (isChecked === true) {
         window.animationStatus = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.animationStatus = 'on';
         document.getElementById("animSwitchValue").checked = true;
      }
   }

   var animStopped = true;

   const conScreenControlHandler = (e) => {
      const isChecked = document.getElementById("onScreenControlsValue").checked;
      
      // add this code for prevent errors
      if (document.getElementById("footerControlDesk")) {
         document.getElementById("footerControlDesk").setAttribute("aria-hidden","false");
      }

      if (isChecked === true) {
         const rotateLeftBtnFocus = document.getElementById("rLeft");
         setTimeout(() => {
            rotateLeftBtnFocus.focus()
         }, 500)
         if (document.getElementById("footerControlDesk")) {
            document.getElementById("footerControlDesk").setAttribute("aria-hidden", "false");
         }
         if (document.getElementById("zoomSlider")) {
            document.getElementById("zoomSlider").setAttribute("aria-hidden", "false");
         }
         if (document.querySelector(".rangeslider")) {
            document.querySelector(".rangeslider").setAttribute("aria-hidden", "false");
         }
         if (document.querySelector(".myslider")) {
            document.querySelector(".myslider").setAttribute("aria-hidden", "false");
         }
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if (window.mob && !window.isipad) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
               navBtn[i].setAttribute("aria-hidden", "false");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }
      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
               navBtn[i].setAttribute("aria-hidden", "true");
            }
            setTimeout(function () {
               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (document.getElementById("footerControlDesk")) {
            document.getElementById("footerControlDesk").setAttribute("aria-hidden", "false");
         }
         if (document.getElementById("zoomSlider")) {
            document.getElementById("zoomSlider").setAttribute("aria-hidden", "false");
         }
         if (document.querySelector(".rangeslider")) {
            document.querySelector(".rangeslider").setAttribute("aria-hidden", "false");
         }
         if (document.querySelector(".myslider")) {
            document.querySelector(".myslider").setAttribute("aria-hidden", "false");
         }

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }

      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }

   const handleMenuClick = (menu_object, e) => {
      let cameraId = menu_object['id'];
      let cameraType = menu_object['type'];
      let center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.hidePopUp();

      // Parent/child relationships
      const parentOf = {
         frontControl: 'dustControl',
         rearControl: 'dustControl',
         alienFX: 'liquidcooled',
         cryotech: 'liquidcooled'
      };

      const childrenOf = {
         liquidcooled: ['alienFX', 'cryotech'],
         dustControl: ['frontControl', 'rearControl']
      };

      // Determine parent/child logic
      const parentId = parentOf[cameraId];

      if (parentId) {
         // Navigating to a child: show parent and siblings
         setActiveSubMenuId(parentId);
         setMenuList(prevMenuList =>
            prevMenuList.map(menu => {
               if (!menu.items) return menu;
               const updatedItems = menu.items.map(item => {
                  if (item.id === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] && parentOf[item.id] !== parentId) return { ...item, subMenuVisibility: false };
                  return item;
               });
               return { ...menu, items: updatedItems };
            })
         );
      } else if (childrenOf[cameraId]) {
         // Navigating to a parent: show all children
         setActiveSubMenuId(cameraId);
         setMenuList(prevMenuList =>
            prevMenuList.map(menu => {
               if (!menu.items) return menu;
               const updatedItems = menu.items.map(item => {
                  if (item.id === cameraId) return { ...item, subMenuVisibility: true };
                  if (childrenOf[cameraId].includes(item.id)) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] && parentOf[item.id] !== cameraId) return { ...item, subMenuVisibility: false };
                  return item;
                  });
               return { ...menu, items: updatedItems };
            })
         );
      } else {
         // Default: collapse submenus
         setActiveSubMenuId(null);
         if (document.querySelector('#iconContainerimg img')) {
            document.querySelector('#iconContainerimg img').style.display = 'none';
         }
      }

      // Update accordion height
      setTimeout(() => {
         const activeMenu = document.querySelector('.menu.active');
         if (activeMenu && activeMenu.nextSibling) {
            const submenuContent = activeMenu.nextSibling.firstChild;
            if (submenuContent) {
               activeMenu.nextSibling.style.height = submenuContent.offsetHeight + 'px';
            setChildTabIndex("1");
            }
         }
      }, 100);

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);
      if (orentation === 90) {
         closeHandle();
      }
      
   };

   var updateAriaLabelSelected = (menuid) => {
      const subMenuItem = document.getElementById(`menu_id_${menuid}`);
      const menuId = `menu_id_${menuid}`;
      // const menuName = subMenuItem.innerText;
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];

      subMenuTabIndex1Arr.forEach(ele => {
         let getId = ele.getAttribute("id");

         if (getId === menuId) {
            // ele.setAttribute("aria-label", `${menuName} selected`);
            ele.setAttribute("aria-current", "true");
         } else {
            // ele.setAttribute("aria-label", "");
            ele.setAttribute("aria-current", "false");
         }
      });
   }

   const setMenuActive = (menu_id, menu_type, e) => {
      let currentClass;
      let preActive;
      var currentActive;
      if (e != undefined) {
         currentActive = e.target.closest('li.subMenuBtn');
         currentClass = currentActive?.classList[0];
         preActive = document.querySelector('.' + currentClass + '.active');
         preActive?.classList.remove('active');
         currentActive?.classList.add('active');
         window.selectedConfig.currentSubMenuClick = currentActive.id;
      }
      else {
         if (document.getElementById('menu_id_' + menu_id) != null) {
            currentActive = document.getElementById('menu_id_' + menu_id);
            currentClass = currentActive.classList[0];
            preActive = document.querySelector('.' + currentClass + '.active');
            if (preActive != null) {
               preActive.classList.remove('active');
            }
            currentActive.classList.add('active');
            window.selectedConfig.currentSubMenuClick = currentActive.id;
         }
      }

      updateAriaLabelSelected(menu_id)
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.currID = menu_id;
      window.selectedButtonType = menu_type;
      window.updateSlider();
   }

   //skip next previous port 
   let skipNextPreviousPortArrId = ["exterior"];

   const childIds = ["alienFX", "cryotech", "frontControl", "rearControl"];

   function setChildTabIndex(value = "1") {
      childIds.forEach(id => {
         const childEl = document.getElementById(`menu_id_${id}`);
         if (childEl) {
            childEl.setAttribute("tabindex", value);
         }
      });
   }

   const parentOf = {
      frontControl: 'dustControl',
      rearControl: 'dustControl',
      alienFX: 'liquidcooled',
      cryotech: 'liquidcooled'
   };

   const onPreviousMode = () => {
      setTimeout(() => {
         const subHeadingEl = document.querySelector('.subHeadingText');
         if (subHeadingEl) {
            subHeadingEl.classList.add(window.dataUI.ui.langcode);
         }
      }, 10);

      window.hidePopUp();
      window.scene._nav.SetRotationCenter([0, 0, 0]);
      window.updateSlider();

      const finalButtonArray1 = ["rearControl", "frontControl"];
      const finalButtonArray2 = buttonArray.filter(id => !skipNextPreviousPortArrId.includes(id));
      const finalButtonArray3 = buttonArray.filter(id => finalButtonArray1.includes(id));
      const finalButtonArray = [...finalButtonArray2, ...finalButtonArray3];

      if (!window.AnimComplated) return;

      const selectedIndex = finalButtonArray.findIndex(id => id === window.checkedButton);

      let prevButton;
      if (window.checkedButton === 'onResetMode' || !window.checkedButton) {
         prevButton = finalButtonArray[finalButtonArray.length - 1];
      } else {
         prevButton = finalButtonArray[selectedIndex - 1] || finalButtonArray[finalButtonArray.length - 1];
      }

      const result = buttonArrayObjectList.find(obj => obj.id === prevButton);
      if (!result) return;

      console.log("Navigating to:", prevButton);

      const parentId = parentOf[prevButton];
      if (parentId) {
         setActiveSubMenuId(parentId);

         setMenuList(prevMenuList =>
            prevMenuList.map(menu => {
               if (!menu.items) return menu;

               const updatedItems = menu.items.map(item => {
                  if (item.id === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] && parentOf[item.id] !== parentId) return { ...item, subMenuVisibility: false };
                  return item;
               });

               return { ...menu, items: updatedItems };
            })
         );

         setTimeout(() => {
            const activeMenu = document.querySelector('.menu.active');
            if (activeMenu && activeMenu.nextSibling) {
               const submenuContent = activeMenu.nextSibling.firstChild;
               if (submenuContent) {
                  activeMenu.nextSibling.style.height = submenuContent.offsetHeight + 'px';
                   setChildTabIndex("1");
               }
            }
         }, 100);
         
      }else{
         if(prevButton == 'pivot' || prevButton == 'interior'){
               setActiveSubMenuId(null);
         setTimeout(() => {
            const activeMenu = document.querySelector('.menu.active');
            if (activeMenu && activeMenu.nextSibling) {
               const submenuContent = activeMenu.nextSibling.firstChild;
               if (submenuContent) {
                  activeMenu.nextSibling.style.height = submenuContent.offsetHeight + 'px';
               }
            }
         }, 50);
         }
      }

      expandMenu(`accordion_${result.type}`);

      window.execute_all(result);

      setTimeout(() => {
         setMenuActive(result.id, result.type);
      }, 50);
   };

   const onNextMode = () => {
      window.hidePopUp();
      setTimeout(() => {
         const subHeadingEl = document.querySelector('.subHeadingText');
         if (subHeadingEl) {
            subHeadingEl.classList.add(window.dataUI.ui.langcode);
         }
      }, 10);

      window.scene._nav.SetRotationCenter([0, 0, 0]);
      window.updateSlider();

      const finalButtonArray = buttonArray.filter(id => !skipNextPreviousPortArrId.includes(id));
      const selectedIndex = finalButtonArray.findIndex(id => id === window.checkedButton);
      let nextButton;

      if (!window.AnimComplated) return;

      if (window.checkedButton === 'onResetMode' || !window.checkedButton) {
         nextButton = finalButtonArray[0];
      } else {
         nextButton = finalButtonArray[selectedIndex + 1] || finalButtonArray[0];
      }

      const result = buttonArrayObjectList.find(obj => obj.id === nextButton);
      if (!result) return;

      console.log("Navigating to:", nextButton);

      const parentOf = {
         frontControl: 'dustControl',
         rearControl: 'dustControl',
         alienFX: 'liquidcooled',
         cryotech: 'liquidcooled'
      };

      //  Reverse map: parent → children
      const childrenOf = {
         liquidcooled: ['alienFX', 'cryotech'],
         dustControl: ['frontControl', 'rearControl']
      };

      const parentId = parentOf[nextButton];

      if (parentId) {
         // Case: We're navigating to a child → show its parent and siblings
         setActiveSubMenuId(parentId);
         setMenuList(prevMenuList =>
            prevMenuList.map(menu => {
               if (!menu.items) return menu;

               const updatedItems = menu.items.map(item => {
                  if (item.id === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] === parentId) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] && parentOf[item.id] !== parentId) return { ...item, subMenuVisibility: false };
                  return item;
               });

               return { ...menu, items: updatedItems };
            })
         );
      } else if (childrenOf[nextButton]) {
         // Case: We're navigating to a parent → show all children too
         setActiveSubMenuId(nextButton);

         setMenuList(prevMenuList =>
            prevMenuList.map(menu => {
               if (!menu.items) return menu;

               const updatedItems = menu.items.map(item => {
                  if (item.id === nextButton) return { ...item, subMenuVisibility: true };
                  if (childrenOf[nextButton].includes(item.id)) return { ...item, subMenuVisibility: true };
                  if (parentOf[item.id] && parentOf[item.id] !== nextButton) return { ...item, subMenuVisibility: false };
                  return item;
               });

               return { ...menu, items: updatedItems };
            })
         );
      } else {
         // Default: Collapse submenus
         setActiveSubMenuId(null);
         if (document.querySelector('#iconContainerimg img')) {
         document.querySelector('#iconContainerimg img').style.display = 'none'
      }
      }

      // Update accordion height
      setTimeout(() => {
         const activeMenu = document.querySelector('.menu.active');
         if (activeMenu && activeMenu.nextSibling) {
            const submenuContent = activeMenu.nextSibling.firstChild;
            if (submenuContent) {
               activeMenu.nextSibling.style.height = submenuContent.offsetHeight + 'px';
                setChildTabIndex("1");
            }
         }
      }, 100);

      expandMenu(`accordion_${result.type}`);
      window.execute_all(result);

      setTimeout(() => {
         setMenuActive(result.id, result.type);
      }, 50);
   };

   const onReset = () => {
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.updateSlider();
      if (!window.AnimComplated) {
         return;
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '' || window.checkedButton === undefined) {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'productView') {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'features') {
         nextButton = 'FunctionMode'
      }
      else {
         nextButton = window.checkedButton;
      }
      window.currID = "reset";
      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
   }

   const expandMenu = (menuId) => {
      //TabIndex Click Functionality
      //make tabIndex -1
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      subMenuTabIndex1Arr.forEach(ele => {
         ele.setAttribute("tabIndex", "-1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "true");
         }
      });
      //TabIndex Click Functionality
      //make tabIndex 1
      let currentTargetAccordion = document.getElementById(`${menuId}`);
      // console.log(currentTargetAccordion, 'currentTargetAccordion')
      let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
      let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');
      let subMenuElementArr = [...subMenuElement];
      subMenuElementArr.forEach(ele => {
         ele.setAttribute("tabIndex", "1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "false");
         }
      });

      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');
         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }
      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {
         document.getElementById(menuId).classList.add('active')
         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }
   }

   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#410290";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }

   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)
   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   //This code is for how to use component resize issue
   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90)
      } else {
         setOrentation((item) => {
            return item;
         })
      }
   }

   window.addEventListener('resize', CanvasResizeFunction)
   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }
   // console.log(menuList,'menulist-----------')
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
               {<div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'none' } : {}}>
                  <span className='portraitButtonText'>{arMob}</span>
               </div>} 
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               <div id="howToUseMenu" tabIndex="-1" aria-label='How to use' role='button' className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick()
               }}>
                  <div className='icon howtouse'> </div>
                  <div className='text' aria-hidden="true">{howToUSE ?? 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandleMenu} />}
               {
                  ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ?

                     <div className="accordion_ProductType portraitButton1" id='accordion_ProductType'>
                        <div className='d-flex'>
                           <span className="portraitButtonText" id="select_type1">{productType && productType[0] ? productType[0]?.mobileTitle : 'Product Type'}</span>
                        </div>
                        <ul className='portraitButtonProducttypeMenu'>
                           {
                              productType[0] && productType[0].items.map((item, index) => {
                                 return (
                                    <React.Fragment key={item.id}>
                                       <li className="subMenuBtn radioButton mob" id={`menu_id_${item.id}`} onClick={e => handleMenuClick(item, e)}>
                                          <label>  <input type="radio" value="product1" /></label>
                                          <span className='mobRadioTitle'>  {item.mobileTitle} </span>
                                       </li>
                                    </React.Fragment>
                                 )
                              })

                           }
                        </ul>
                     </div> : null
               }
               <div className='accordionContainer'>
                  {
                     ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ? menuList.filter(list => list.id != "ProductType").map((list) => {

                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" &&
                                 <SubmenuList
                                    subMenuList={list.items}
                                    orentation={orentation}
                                    handleMenuClick={handleMenuClick}
                                    activeSubMenuId={activeSubMenuId} // <-- Add this prop
                                 />}
                           </React.Fragment>
                        )
                     })
                        :
                        menuList.map((list) => {
                           // console.log(list,'list----')
                           return (
                              <React.Fragment key={list.id}>
                                 {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                    <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                       <div className={`icon ${list.id}`} ></div>
                                       <div className='text'>{list.title} {list.title}</div>
                                    </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} aria-expanded={false} role='button' tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                       if (e.key !== 'Enter') {
                                          return
                                       } accordionMenu(e)
                                    }}>
                                       <>
                                          <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                          <div className={`mob_icon mob_icon_${list.id}`}></div>
                                          <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                          <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                       </>
                                    </div>
                                 }
                                 {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick}  activeSubMenuId={activeSubMenuId} />}
                              </React.Fragment>
                           )
                        })

                  }
               </div>
               <div id="menuFooter">
               <RgbColorPicker  />
                  {myJson.QRSupport && <div id="qrCode">
                     <QRCode size={130} value={window.linkForGenerateQR} style={{ height: "auto" }} aria-label='qr code image'/> <br />  {/* qr code changes */}
                     <span className='text'> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     <span aria-hidden="true">{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="-1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={false} aria-label='reduce transitions switch' />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className='' aria-hidden='true'>{onScreenControls ?? 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext ?? 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="-1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} aria-label='on screen controls switch' />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandleMenu}/>
         </div>
      </>
   );
}

export default Menu;